<template >
  <div class="error-403">
    <div class="error-title">亲爱的用户，您无权访问该页面...</div>
    <a class="error-btn" href="/portal">
      返回首页
    </a>
  </div>
</template>
<script>
import $ from 'jquery';
export default {
  name: 'error403',
  created() {
    this.$root.layout.isShowAside = false;
    this.$root.layout.isShowTop = false;
    this.$root.layout.isShowNav = false;
    this.$root.layout.isShowHeader = false;
    this.$root.layout.isShowBottom = false;
    this.$root.layout.isLoading = false;
    this.$root.layout.isBackground = false;
  },
  mounted() {
    $('.container_box').css({
      background: '#fff'
    });
    $('.container_bg-red').css({
      background: '#fff'
    });
  }
};
</script>
<style lang="less">
.error-403 {
  -webkit-font-smoothing: auto;
  background-color: #fff;
  background-image: url('../../assets/img/error-403.jpg');
  background-repeat: no-repeat;
  background-position: center center;
  width: 100%;
  position: relative;
  .error-title {
    color: #525252;
    font-family: 'Microsoft YaHei';
    position: absolute;
    font-size: 16px;
    left: 41%;
    top: 50%;
  }
  .error-btn {
    position: absolute;
    font-family: 'Microsoft YaHei';
    font-size: 16px;
    left: 46.4%;
    top: 78%;
    color: #fff;
    background-color: #d03f46;
    padding: 12px;
  }
}
</style>
